import { render, staticRenderFns } from "./CatalogSelectedChapters.vue?vue&type=template&id=5fc1f590&scoped=true&"
import script from "./CatalogSelectedChapters.vue?vue&type=script&lang=ts&"
export * from "./CatalogSelectedChapters.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogSelectedChapters.vue?vue&type=style&index=0&id=5fc1f590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1f590",
  null
  
)

export default component.exports